import { Select2 } from "library/select2-react-component";
import React, { useEffect, useState } from "react";
import "select2-component/dist/select2.min.css";
import { mapMultiClassnames } from "utils/map-modifier";
import { nonAccentVietnamese } from "utils/utils-common";
import "./index.scss";

interface SelectProps {
  label: string;
  value: string | boolean;
}
interface Select2NewProps {
  disabled?: boolean;
  options: SelectProps[];
  placeholder?: string;
  modifiers?: Modifiers;
  name?: string;
  setValue?: any;
  initValue?: any;
  customSearchEnable?: boolean;
  open?: () => void;
}

const Select2New: React.FC<Select2NewProps> = ({
  open,
  placeholder,
  initValue,
  name,
  setValue,
  options,
  modifiers,
  disabled,
  customSearchEnable = true,
}) => {
  const [valueDisplay, setValueDisplay] = useState("");
  const [data, setData] = useState<SelectProps[]>([]);
  const defaultData = [
    {
      label: `Chọn ${placeholder}`,
      value: "",
    },
  ];
  useEffect(() => {
    setValueDisplay(initValue);
  }, [initValue, name]);
  const update = (value: any) => {
    setValueDisplay(value);
    setValue && setValue(name, value);
  };

  const onSearch = (text: string) => {
    let newData = options.filter(
      option =>
        nonAccentVietnamese(option.label.toLowerCase()).indexOf(
          nonAccentVietnamese(text.toLowerCase()),
        ) > -1,
    );
    setData(text ? newData : defaultData.concat(options));
  };
  useEffect(() => {
    setData(defaultData.concat(options));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return (
    <div className={mapMultiClassnames("a-select2-new", modifiers)}>
      <Select2
        open={() => {
          setData(defaultData.concat(options));
          open && open();
        }}
        update={update}
        search={onSearch}
        value={valueDisplay}
        placeholder={placeholder}
        customSearchEnabled={customSearchEnable}
        data={data}
        {...(disabled ? { disabled } : {})}
      />
    </div>
  );
};

export default Select2New;
